import { z } from "zod";
import {
  DRYBULK_CARGO_OPS_LANG_BASE,
  FINAL_DRAFT_SURVEY_PATTERN,
  TOLERANCE_PATTERN,
} from "../constants";

type Translate = (key: string, options?: Record<string, unknown>) => string;

export const L_FDS = `${DRYBULK_CARGO_OPS_LANG_BASE}.final-draft-survey`;
export const L_TOLERANCE = `${DRYBULK_CARGO_OPS_LANG_BASE}.tolerance`;

export const FINAL_DRAFT_SURVEY_FIELDS = { TOTAL: "total" } as const;
export const INTERMEDIATE_SURVEY_FIELDS = { AMOUNT: "amount" } as const;
export const TOLERANCE_FIELDS = { TOLERANCE_PCT: "tolerancePct" } as const;

const isPositive = (value: string) => FINAL_DRAFT_SURVEY_PATTERN.test(value) && Number(value) > 0;

export const finalDraftSurveySchema = (t: Translate) =>
  z.object({
    [FINAL_DRAFT_SURVEY_FIELDS.TOTAL]: z
      .string()
      .trim()
      .min(1, t("form-validation.mandatory", { label: t(`${L_FDS}.label`) }))
      .refine((value) => value === "" || isPositive(value), t(`${L_FDS}.errors.total`)),
  });
export type FinalDraftSurveyFormData = z.infer<ReturnType<typeof finalDraftSurveySchema>>;
export const finalDraftSurveyDefaultValues: FinalDraftSurveyFormData = { total: "" };

export const intermediateSurveySchema = (t: Translate) =>
  z.object({
    [INTERMEDIATE_SURVEY_FIELDS.AMOUNT]: z
      .string()
      .trim()
      .refine((value) => value === "" || isPositive(value), t(`${L_FDS}.errors.amount`)),
  });
export type IntermediateSurveyFormData = z.infer<ReturnType<typeof intermediateSurveySchema>>;

export const toleranceSchema = (t: Translate) =>
  z.object({
    [TOLERANCE_FIELDS.TOLERANCE_PCT]: z
      .string()
      .trim()
      .min(1, t("form-validation.mandatory", { label: t(`${L_TOLERANCE}.dialog.field`) }))
      .refine(
        (value) => value === "" || (TOLERANCE_PATTERN.test(value) && Number(value) <= 100),
        t(`${L_TOLERANCE}.errors.tolerance`),
      ),
  });
export type ToleranceFormData = z.infer<ReturnType<typeof toleranceSchema>>;
